export const UPDATE_DESIGN_OPTIONS = 'fabricDesign/*/UpdateOptions';
export const RESET_DESIGN_OPTIONS = 'fabricDesign/*/ResetOptions';
export const UPDATE_PRISTINE_UYO = 'fabricDesign/*/UpdatePristineUyo';
export const REVERT_TO_BASIC = 'fabricDesign/*/RevertToBasic';
export const SET_TEMPLATE_SNAPSHOT = '/Template/*/SNAPSHOT';
export const SET_EDITING_MOBILE = 'fabricDesign/*/SetEditingMobile';
export const SET_UPLOADED_IMAGE = 'fabricDesign/*/SetUploadedImage';
